<span
  [matTooltipClass]="'icon-tooltip-marker'"
  [matTooltip]="tooltip"
  class="material-icons icon-tooltip"
>error_outline</span>
